export const PROVIDER = {
    apikey: "fT0hdvjjCiY6Sd30iA6AYih7Tj2qDR4mYuU0E68AHcyiASJazzICJqIvP0qXwmnR",
    APP_ID: "devicesync-gchbh",
    dataSource: "Cluster0",
    dataBase: "todo"
}